// SDK version for the analytics SessionStart beacon (build-time injected).
//
// `__HAVIK_SDK_VERSION__` is defined by the vite configs from
// npm_package_version at build time; `typeof` on an undeclared identifier is
// safe, so test runners and consumers that bypass the define get 'dev'.
// Fidelity note: the value is only as good as package.json at build time —
// semantic-release stamps it during the release pipeline, local builds say
// whatever the placeholder version is.
declare const __HAVIK_SDK_VERSION__: string | undefined;

export const SDK_VERSION: string =
  typeof __HAVIK_SDK_VERSION__ === 'string' ? __HAVIK_SDK_VERSION__ : 'dev';
